import React from 'react';
import { Link } from 'react-router-dom';
import Skeleton from '../../Components/Skeleton';
import { isNewTabClick } from '../../hooks/useOpenPath';

export type ParkingTab = 'areas' | 'queue';

interface ParkingTabsProps {
    active: ParkingTab;
    /** Where each tab links (Cmd/Ctrl-click opens it in a new tab). */
    hrefs: Record<ParkingTab, string>;
    /** Called on a plain click, before the link navigates, so the tab switches at once. */
    onSelect: (tab: ParkingTab) => void;
    /** Number of active queue entries, shown as "Kö (n)". */
    activeCount: number | null;
}

/** "Områden | Kö (n)" tab bar of the Parkering page, styled like the Komponenttyper tabs. */
const ParkingTabs: React.FC<ParkingTabsProps> = ({ active, hrefs, onSelect, activeCount }) => {
    const tabProps = (tab: ParkingTab) => ({
        to: hrefs[tab],
        role: 'tab',
        'aria-selected': active === tab,
        className: `parking-tab ${active === tab ? 'active' : ''}`,
        onClick: (e: React.MouseEvent) => { if (!isNewTabClick(e)) onSelect(tab); },
    });
    return (
        <div className="parking-tab-bar" role="tablist">
            <Link {...tabProps('areas')}>
                Områden
            </Link>
            <Link {...tabProps('queue')}>
                Kö {activeCount !== null ? `(${activeCount})` : <Skeleton inline width="1.6em" />}
            </Link>
        </div>
    );
};

export default ParkingTabs;
